import { ApiService, nullable } from '@abb-procure/api';
import { Injectable } from '@angular/core';
import {
  number as ioNumber,
  record as ioRecord,
  string as ioString,
} from 'io-ts';
import { DailyExchangeRateResponse } from '../types/daily-exchange-rate-response.type';

@Injectable({
  providedIn: 'root',
})
export class ExchangeRatesApiService extends ApiService {
  async getYearlyExchangeRate(
    quoteCurrencyId: number,
  ): Promise<Record<string, number> | null> {
    try {
      return await this.get<Record<string, number>>(
        `Organisation/Lookup/Currency/Exchange/${quoteCurrencyId}`,
        ioRecord(ioString, ioNumber),
      );
    } catch (error) {
      return this.catchError(
        error,
        'There was an issue retrieving the currency exchange rates.',
      );
    }
  }

  async getDailyExchangeRate(
    quoteCurrencyId: number,
  ): Promise<DailyExchangeRateResponse | null> {
    try {
      return await this.get<DailyExchangeRateResponse>(
        `Organisation/lookup/Currency/Exchange/Daily/${quoteCurrencyId}`,
        nullable(DailyExchangeRateResponse),
      );
    } catch (error) {
      return this.catchError(
        error,
        'There was an issue retrieving the currency exchange rates.',
      );
    }
  }
}
